import { useReducer, useState } from "react";
import RmaFilterBar from "./RmaFilterBar";
import RmaTable from "./RmaTable";
import { CustomerRmaFilter } from "./customerRmaTypes";
import { FormControlLabel, Grid, Switch } from "@mui/material";

const initialFilters: CustomerRmaFilter = {
  nameId: "",
  serial: "",
  shipDateFrom: "",
  shipDateTo: "",
};

const Rma = () => {
  const [filters, setFilters] = useReducer(
    (curVals: CustomerRmaFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );
  const [history, setHistory] = useState<boolean>(false);
  return (
    <>
      <RmaFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <Grid container>
        <Grid item>
          <FormControlLabel
            control={
              <Switch
                checked={history}
                onChange={() => {
                  setHistory((value) => !value);
                }}
                color="primary"
              />
            }
            label="Show Closed RMAs"
          />
        </Grid>
      </Grid>
      <RmaTable filters={filters} history={history} />
    </>
  );
};

export default Rma;
